import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'

import GlobalItems from 'components/Item'
import ListFilters from 'components/Item/ListFilters'
import Layout from 'components/Layout'

import { getCurrentVenueUuid } from 'store/Venues/selector'
import { loadPriceLevels } from 'store/PriceLevels/actions'
import { loadSalesEventTypes } from 'store/SalesEventTypes/actions'
import { loadCategories } from 'store/Categories/actions'
import { loadMenus } from 'store/Menus/actions'
import { loadRevenueCenters } from 'store/RevenueCenters/actions'
import { getItemsPaginationConfig } from 'store/Items/selector'

const Items = () => {
  const currentVenueUuid = useSelector(getCurrentVenueUuid)
  const paginationConfig = useSelector(getItemsPaginationConfig)

  const dispatch = useDispatch()

  useEffect(() => {
    if (!isEmpty(currentVenueUuid)) {
      dispatch(loadPriceLevels(currentVenueUuid))
      dispatch(loadSalesEventTypes(currentVenueUuid))
      dispatch(loadCategories(currentVenueUuid))
      dispatch(loadMenus(currentVenueUuid))
      dispatch(loadRevenueCenters(currentVenueUuid))
    }
    //eslint-disable-next-line
  }, [currentVenueUuid, dispatch])

  return (
    <Layout
      mainContent={
        <GlobalItems
          paginationConfig={{
            ...paginationConfig,
            venueUuid: currentVenueUuid,
          }}
        />
      }
      navbarContent={
        <ListFilters
          paginationConfig={{
            ...paginationConfig,
            venueUuid: currentVenueUuid,
          }}
        />
      }
      isSidebar
      title="Items"
    />
  )
}

export default Items
